import CampaignComponentVariable from "./CampaignComponentVariable";
export const isCampaignComponentPartnerEnumListVariableResponse = (response) => {
    return (response.type === "PARTNER_ENUM_LIST" &&
        "webhook_id" in response &&
        "options" in response);
};
export const isCampaignComponentPartnerEnumListVariable = (variable) => {
    return variable instanceof CampaignComponentPartnerEnumListVariable;
};
export class CampaignComponentPartnerEnumListVariable extends CampaignComponentVariable {
    constructor(variableResponse, context) {
        super(variableResponse, context);
        this.webhook_id = variableResponse.webhook_id;
        this.options = variableResponse.options;
    }
    getWebhookId() {
        return this.webhook_id;
    }
    getOptions() {
        return this.options;
    }
}
